import type { PresentedSearchCmdBarResult } from '@/features/cmd-bar/search-result-presentation';

import type { Thread } from '@littlebird/sdk';

export type ChatSearchResult = Extract<
  PresentedSearchCmdBarResult,
  { type: 'thread' | 'message' }
>;

export type ChatListItem =
  | { type: 'chat'; thread: Thread }
  | { type: 'search-result'; result: ChatSearchResult };

export function getChatListItemKey(item: ChatListItem): string {
  return item.type === 'chat' ? item.thread.id : item.result.id;
}

export function getSearchResultThreadId(item: ChatSearchResult): string {
  return item.type === 'message' ? item.threadId : item.id;
}
